/**
 * ファイルをアップロードする際にサポートしている拡張子
 * @constant {string[]}
 */
export const fileAllowedExtensions = [
    'jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'tiff', 'tif', 'ico',
    'mp4', 'webm', 'avi', 'mov', 'mkv',
    'mp3', 'wav', 'ogg', 'flac',
    'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'rtf',
    'zip', 'rar', 'tar', 'gz',
];
/**
 * フォーム全体のファイルアップロード上限(MB)
 * @constant {number}
 */
export const maxSizeMB = 10;
//# sourceMappingURL=constants.js.map